<script setup>
import {computed} from "vue";

const props = defineProps({
    type: {
        type: String,
        default: 'primary'
    },
    active: Boolean,
    disabled: Boolean,
});
const className = computed(() => {
    const disabled = ' pointer-events-none';
    const active = ' bg-blue-5';
    let notActive = ' bg-white hover:bg-blue-5';
    if (props.active) {
        switch (props.type) {
            case 'danger':
            case 'warning':
                return active + disabled + ' text-accent-red fill-accent-red stroke-accent-red'
            default:
                return active + disabled + ' text-accent-blue fill-accent-blue stroke-accent-blue';
        }
    }
    if (props.disabled) {
        notActive += disabled + ' grayscale';
    }
    switch (props.type) {
        case 'danger':
            return notActive + ' text-accent-red fill-accent-red stroke-accent-red'
        case 'warning':
            return notActive + ' text-dark-light fill-dark-light stroke-dark-light hover:text-accent-red hover:fill-accent-red hover:stroke-accent-red';
        default:
            return notActive + ' text-dark-light fill-dark-light stroke-dark-light hover:text-accent-blue hover:fill-accent-blue hover:stroke-accent-blue';
    }
});
</script>

<template>
    <!-- Sized to match a PrimeVue Select option (#17): 8px/12px padding, and the
         12px radius the preset gives `list.option`. Bare `rounded` IS 12px on the
         KEDO scale. 12px is the ceiling, not a preference: the panel is 16px with
         a 4px inset, and a nested radius above 16−4 fights the panel's corners. -->
    <button class="flex items-center gap-4 rounded transition-all duration-100 py-4 px-6 text-base w-full"
            :class="className" type="button" :disabled="disabled">
        <slot/>
    </button>
</template>
